import { useTranslation } from "@redotech/redo-i18n";
import type { DamagedState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const DamagedDetails = memo(function DamagedDetails({
  disabled,
}: ConditionTypeDetailsProps<DamagedState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Condition")}
      </Text>
      <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
        {t(
          "Applies when at least one item in the return is submitted as damaged.",
        )}
      </Text>
    </Flex>
  );
});
